import { fireNonCancelableEvent } from '../internal/events';
export function onChangeEffect(editor, onChange) {
    if (!editor) {
        return;
    }
    if (!onChange) {
        editor.removeAllListeners('change');
    }
    var callback = function () { return fireNonCancelableEvent(onChange, { value: editor.getValue() }); };
    editor.on('change', callback);
    return function () { return editor.off('change', callback); };
}
//# sourceMappingURL=listeners.js.map